import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import { columnDefs, defaultColumnDefs } from './DevotionalGroupGrid.config';
// eslint-disable-next-line
import styles from 'ag-grid-community/dist/styles/ag-theme-fresh.css';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';

const mapStateToProps = state => {
  const devotionalGroups = state.firestore.data.devotionalGroups;
  return ({
    devotionalGroups,
    rowData: devotionalGroups ? Object.values(devotionalGroups) : [],
  });
};

class DevotionalGroupGrid extends Component {

  render() {
    return (
      <div
        id="devotional-group-grid"
        className="ag-theme-fresh"
        style={{
          height: '100%',
          width: '100%',
        }}
      >
        <AgGridReact
          defaultColDef={defaultColumnDefs}
          deltaRowDataMode={true}
          columnDefs={columnDefs}
          getRowNodeId={data => data.id}
          rowData={this.props.rowData}>
        </AgGridReact>
      </div>
    );
  }
}

export default compose(
  firestoreConnect(['devotionalGroups']), // or { collection: 'todos' }
  connect(mapStateToProps),
)(DevotionalGroupGrid);
